<template>
	<el-dialog
		v-dialogDrag
		class="chat-merge-forward-dialog im-dialog-shell im-dialog-shell--lg im-dialog-shell--mobile-center"
		:visible.sync="show"
		width="680px"
		custom-class="chat-merge-forward-panel"
		:close-on-click-modal="false"
		append-to-body
	>
		<div slot="title" class="merge-forward-titlebar">
			<div class="title-main">{{ mergeTitle }}</div>
			<div class="title-meta">{{ mergeSummary }}</div>
		</div>
		<div class="merge-forward-dialog">
			<el-scrollbar class="message-list">
				<div class="message-item" v-for="(msg, index) in mergeMessages" :key="msg.id || index">
					<chat-history-item :headImage="msg.sendHeadImage" :showName="msg.sendNickName" :msgInfo="msg">
					</chat-history-item>
				</div>
			</el-scrollbar>
		</div>
	</el-dialog>
</template>

<script>
import ChatHistoryItem from './ChatHistoryItem.vue';

export default {
	name: "ChatMergeForward",
	components: {
		ChatHistoryItem
	},
	data() {
		return {
			show: false,
			mergeData: {}
		}
	},
	computed: {
		mergeMessages() {
			if (!Array.isArray(this.mergeData.messages)) {
				return [];
			}
			return this.mergeData.messages;
		},
		mergeTitle() {
			return this.mergeData.title || '聊天记录';
		},
		mergeSummary() {
			return `${this.mergeMessages.length} 条`;
		}
	},
	methods: {
		open(mergeData) {
			this.mergeData = mergeData || {};
			this.show = true;
		},
		close() {
			this.show = false;
		}
	}
}
</script>

<style lang="scss">
.chat-merge-forward-panel {
	width: min(680px, calc(100vw - 28px)) !important;
	max-height: calc(100vh - 24px) !important;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	border-radius: 6px;
	overflow: hidden;
	border: 1px solid var(--im-surface-panel-border);
	background: var(--im-chat-bg);
	box-shadow: none;
}

.chat-merge-forward-panel .el-dialog__header {
	padding: 14px 18px 10px;
	border-bottom: 1px solid var(--im-surface-panel-border);
	background: var(--im-chat-bg);
}

.chat-merge-forward-panel .el-dialog__headerbtn {
	top: 16px;
	right: 16px;
}

.chat-merge-forward-panel .el-dialog__body {
	flex: 1;
	min-height: 0;
	overflow: hidden;
	padding: 0;
}

.merge-forward-titlebar {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 12px;
	padding-right: 28px;

	.title-main {
		flex: 1;
		min-width: 0;
		font-size: 15px;
		line-height: 1.35;
		font-weight: 600;
		color: var(--im-text-color);
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.title-meta {
		display: inline-flex;
		align-items: center;
		height: 22px;
		padding: 0 8px;
		border-radius: 4px;
		background: rgba(var(--im-primary-rgb), 0.08);
		color: var(--im-color-primary);
		font-size: 12px;
		font-weight: 600;
		flex-shrink: 0;
	}
}

.merge-forward-dialog {
	.message-list {
		padding: 0 16px;
		height: min(58vh, calc(100vh - 118px));

		.message-item {
			padding: 10px 0 12px;
			border-bottom: 1px solid var(--im-surface-panel-border);

			&:last-child {
				border-bottom: 0;
			}
		}
	}
}

@media (max-width: 640px) {
	.chat-merge-forward-dialog {
		display: flex;
		align-items: center;
		padding: 12px;
		overflow: hidden;
	}

	.chat-merge-forward-panel {
		width: calc(100vw - 24px) !important;
		max-height: min(700px, calc(100vh - 56px)) !important;
		margin: 0 auto !important;
		border-radius: 6px;
	}

	.chat-merge-forward-panel .el-dialog__header {
		padding: 12px 16px 10px;
	}

	.chat-merge-forward-panel .el-dialog__headerbtn {
		top: 14px;
		right: 14px;
	}

	.merge-forward-titlebar {
		gap: 10px;
		padding-right: 26px;

		.title-main {
			font-size: 14px;
		}
	}

	.merge-forward-dialog {
		.message-list {
			padding: 0 12px;
			height: min(540px, calc(100vh - 190px));
		}
	}
}
</style>
